<template>
    <div v-show="!isLoading">
        <div class="header_unit header_bg_blue">
            <div class="header_box">
                <div class="menu_left">
                    <a href="#" role="button" class="router-link-active" @click.prevent.stop="openAlertModal()" >TOPへ</a>
                </div>
                <div class="menu_center">
                    <p class="menu_center_tex_s">{{menuNameUpper}}</p>
                    <p class="menu_center_tex_l">{{menuNameLower}}</p>
                </div>
            </div>
        </div>

        <div class="main_unit">
            <div class="top_unit">
                <div class="top_right_box_mgt">プレビュー表示 </div>
            </div>
            <div class="chori_check_menu2">
                <ul>
                    <li v-for="(menuData, index) in cookingCheckButtonSettings" :key="menuData.importantButtonId" v-show="menuData.displayFlg" >
                        <div :class="classList['a'][index]">
                            {{menuData.upperButtonName}}
                        </div>
                        <div class="chori_check_tex2">
                            <a href="#" role="button" class="router-link-active" @click.prevent.stop="openAlertModal()" >{{menuData.lowerButtonName}}</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <AlertDialog :display="showModal.alertDisplay" @close="closeAlertModal"/>
    </div>
</template>

<script>
    import AlertDialog from '@/app/components/common/AlertDialog.vue'

    export default {
        name: "CookingCheckIndexPreview",
        components: {
            AlertDialog
        },
        props:{
        },
        computed: {
            brandId () {
                return this.$store.getters['brand/id']
            },
            cookingCheckButtonId () {
                return this.$store.getters['checkPage/id'];
            },
            cookingCheckButtonNo () {
                return this.$store.getters['checkPage/buttonNo'];
            },
            upperButtonName () {
                return this.$store.getters['preview/upperButtonName'];
            },
            lowerButtonName () {
                return this.$store.getters['preview/lowerButtonName'];
            },
            displayFlg () {
                return Number(this.$store.getters['preview/displayFlg']);
            }
        },
        watch: {
            topButtonSettings () {
                let button = this.topButtonSettings.filter((x) => x.topButtonId === Number(this.$route.params.menuId)).shift();
                this.menuNameUpper = 'upperButtonName' in button ? button.upperButtonName : ''
                this.menuNameLower = 'lowerButtonName' in button ? button.lowerButtonName : ''
            }
        },
        data() {
            return {
                isLoading:true,
                menuNameUpper: '',
                menuNameLower: '',
                showModal: {
                    alertDisplay:false
                },
                classList: {
                    a: [
                        'chori_check_index chori_bg01',
                        'chori_check_index chori_bg02',
                        'chori_check_index chori_bg03',
                        'chori_check_index chori_bg04',
                        'chori_check_index chori_bg05',
                    ]
                },
                topButtonSettings:[],
                cookingCheckButtonSettings: [
                    {
                        "importantButtonId": 0,
                        "upperButtonName": "",
                        "lowerButtonName": "",
                        "displayFlg": null
                    }
                ]
            }
        },
        created() {
            this.init();
        },
        methods: {
            init() {
                this.$axios
                    .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/menu/', {params: {datetime: this.dateFormat()}})
                    .then(response => {
                        this.topButtonSettings = response.data.topButtonSettings;
                        let list = response.data.cookingCheckButtonSettings;
                        this.cookingCheckButtonSettings = this.replaceCookingCheckButtonList(list);
                    })
                    .catch((err) => {
                        let error = {
                            button: {
                                path: {name: ''}
                            },
                            canBack: false
                        };
                        if (err.customError) {
                            error = Object.assign(error, err.customError)
                        }
                        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                    }).finally(() => this.isLoading = false);
            },
            replaceCookingCheckButtonList(list) {
                let button = {
                    cookingCheckButtonId: this.cookingCheckButtonId,
                    cookingCheckButtonNo: this.cookingCheckButtonNo,
                    displayFlg: this.displayFlg,
                    upperButtonName: this.upperButtonName,
                    lowerButtonName: this.lowerButtonName,
                };

                let index = list.findIndex((v) => v.cookingCheckButtonId === this.cookingCheckButtonId);

                let deleteCount = 0;
                if(index > -1) {
                    // 配列に存在すれば置き換える
                    deleteCount = 1;
                }

                list.splice(index, deleteCount, button);

                return list;
            },
            openAlertModal() {
                this.showModal.alertDisplay = true;
            },
            closeAlertModal() {
                this.showModal.alertDisplay = false;
            },
            dateFormat(){
                let nowDate = new Date();
                nowDate.setDate(nowDate.getDate() + 1);
                let year = nowDate.getFullYear();
                let month = ('0' + (nowDate.getMonth()+1)).slice(-2);
                let day = ('0' + nowDate.getDate()).slice(-2);
                let hours = ('0' + nowDate.getHours()).slice(-2);
                let minutes = ('0' + nowDate.getMinutes()).slice(-2);
                let seconds = ('0' + nowDate.getSeconds()).slice(-2);

                let format_str = 'YYYYMMDDhhmmss';
                format_str = format_str.replace(/YYYY/g,year);
                format_str = format_str.replace(/MM/g,month);
                format_str = format_str.replace(/DD/g,day);
                format_str = format_str.replace(/hh/g,hours);
                format_str = format_str.replace(/mm/g,minutes);
                format_str = format_str.replace(/ss/g,seconds);
                return format_str;
            }
        }
    }
</script>